import ApiService from "../ApiService";
import ApiServiceV2 from "../ApiServiceV2";
const user = JSON.parse(localStorage.getItem("user"));

export default class EditorialService {
  static getModule = async (params) => {
    const instance = await ApiService();
    return instance.get("/module");
  };
  static getDataMall = async (params) => {
    let property_id = `&property_id=${user.operational.id}`;
    let num,
      cursor,
      keyword,
      type,
      level,
      approved,
      deleted,
      is_landing,
      is_active,
      current_date;

    if (params.num && params.num !== "") {
      num = `num=${params.num}`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    if (params.type && params.type !== "") {
      type = `&type=${params.type}`;
    }

    if (params.deleted && params.deleted !== "") {
      deleted = `&removed=${params.deleted}`;
    } else {
      deleted = `&removed=false`;
    }

    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }
    if (params.is_landing && params.is_landing !== "") {
      is_landing = `&is_landing=${params.is_landing}`;
      deleted = "";
    }
    if (
      (params.is_active && params.is_active !== "") ||
      params.is_active === 0
    ) {
      is_active = `&is_active=${params.is_active}`;
    }
    if (params.current_date && params.current_date !== "") {
      current_date = `&current_date=${params.current_date}`;
    }

    const instance = await ApiServiceV2();
    return instance.get(
      `/editorial?${num || ""}${cursor || ""}${keyword || ""}${deleted || ""}${
        is_landing || ""
      }${current_date || ""}${is_active || ""}`
    );
  };
  static getData = async (params) => {
    let num, cursor, property_id, tenant_id, keyword, type;

    if (params.num && params.num !== "") {
      num = `num=${params.num}`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    if (params.property_id && params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }

    if (params.tenant_id && params.tenant_id !== "") {
      tenant_id = `&tenant_id=${params.tenant_id}`;
    }

    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    if (params.type && params.type !== "") {
      type = `&type=${params.type}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/shopfront?${num || ""}${property_id || ""}${tenant_id || ""}${
        cursor || ""
      }${keyword || ""}`
    );
  };

  // Promotion Tenant
  static getDataTenant = async (params) => {
    let property_id = `&property_id=${user.operational.id}`;
    let tenant_id =
      user.type === "tenant"
        ? `&tenant_id=${user.tenant.id}`
        : params.tenant_id
        ? `&tenant_id=${params.tenant_id}`
        : "";

    let num, cursor, keyword, type, approved, deleted, level, is_landing;

    if (params.num && params.num !== "") {
      num = `num=${params.num}`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    if (params.type && params.type !== "") {
      type = `&type=${params.type}`;
    }
    if (params.is_landing && params.is_landing !== "") {
      is_landing = `&is_landing=${params.is_landing}`;
    }

    if (params.approved && params.approved !== "") {
      approved = `&approved=${params.approved}`;
    } else {
      approved = `&approved=false`;
    }

    if (params.deleted && params.deleted !== "") {
      deleted = `&removed=${params.deleted}`;
    } else {
      deleted = `&removed=false`;
    }

    const instance = await ApiServiceV2();
    return instance.get(
      `/editorial?${num || ""}${property_id}${tenant_id}${type || ""}${
        cursor || ""
      }${keyword || ""}${deleted || ""}${is_landing || ""}${approved || ""}`
    );
  };

  static getDataShopfront = async (params) => {
    let num, cursor, property_id, tenant_id, keyword, type;

    if (params.num && params.num !== "") {
      num = `num=${params.num}`;
    }

    if (params.cursor && params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    if (params.property_id && params.property_id !== "") {
      property_id = `&property_id=${params.property_id}`;
    }

    if (params.tenant_id && params.tenant_id !== "") {
      tenant_id = `&tenant_id=${params.tenant_id}`;
    }

    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    if (params.type && params.type !== "") {
      type = `&type=${params.type}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/master_category?${num || ""}${property_id || ""}${tenant_id || ""}${
        cursor || ""
      }${keyword || ""}`
    );
  };

  static storeData = async (params) => {
    // console.log("masuk sini");
    const instance = await ApiServiceV2();

    return instance.post(`/editorial`, params);
  };

  static putData = async (params, id) => {
    const instance = await ApiServiceV2();

    return instance.put(`/editorial/` + id, params);
  };
  static patchData = async (id, params) => {
    const instance = await ApiServiceV2();

    return instance.patch(`/editorial/` + id, params);
  };

  static deleteData = async (id) => {
    const instance = await ApiServiceV2();
    return instance.delete(`/editorial/` + id);
  };

  static cekHighlight = async (params) => {
    const instance = await ApiServiceV2();
    return instance.get(`/checkeditoriallanding`);
  };
}
